import React from 'react';
import { connect } from "react-redux";
import { Button, Row, Col, Container } from 'react-bootstrap'

import CurrentUser from './CurrentUser';
import CurrentUserChangePassword from './CurrentUserChangePassword';
import Logout from './Logout';

import SelectField from '../common/form/SelectField';
import { LOADING_STATUES } from "../constants/constants";

import landnotification_logo from '../../img/trimin_landnotification_verysmall.png';
import { userProfileIcon, warningSmallIcon } from "../../img/font_awesome/font_awesome"

import translations from "../../config/translation/home_translations.json"
import { selectLanguage } from '../../redux/actions/languageActions';
import Loading from '../common/modal/Loading';

const mapStateToProps = state => {
	return {
		countyConfigUserLockout: state.countyConfigUserLockoutReducer,
		appTitle: state.countyConfigCommonReducer.appTitle,
		countyName: state.countyConfigCommonReducer.countyName,
		currentUserId: state.currentUserReducer.userId,
		currentUserName: state.currentUserReducer.username,
		role: state.currentUserReducer.role,
		language: state.languageReducer ? state.languageReducer : 'ENGLISH',
		languages: state.countyConfigLanguagesReducer  
	};
}

const matchDispatchToProps = (dispatch) => {
  return {
    selectLanguage: (language, callback) => dispatch(selectLanguage(language, callback))
  }
}

class InformationMain extends React.Component {
   
    state = {
		showCurrentUser: false,
		showCurrentUserChangePassword: false,
		showLogout: false,
		loadingStatus: ''
	};
	
	handleClickAbout = (event) => {
		event.preventDefault();
		this.props.showAbout(true);
	}

	handleLanguageChange = (event) => {
		event.preventDefault();

		if (this.showLoading() === true) {
			this.props.selectLanguage(event.target.value, this.hideLoading); //ck add callback
		}
	}

	handleClickCurrentUser = (event) => {
		if (event) {
			event.preventDefault();
		}
		this.setState({
			showCurrentUser: true
		});
	}

	handleCloseCurrentUser = () => {
		this.setState({
			showCurrentUser: false
		});
	}

	handleClickCurrentUserChangePassword = () => {
		this.setState({
			showCurrentUserChangePassword: true
		});
	}

	handleCloseCurrentUserChangePassword = () => {
		this.setState({
			showCurrentUserChangePassword: false
		});
	}

	handleClickLogout = (event) => {
		event.preventDefault();
		this.setState({
			showLogout: true
		});
	}

	handleCloseLogout = () => {
		this.setState({
			showLogout: false
		});
	}

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	hideLoading = (loadingStatus) => {
		if (loadingStatus === 'ERROR') {
			this.setState({
				loadingStatus: ""
			})
		} else {
			this.setState({
				loadingStatus: ""
			})
		}
	}

	render() {
		const languageOptions = [
		{ code: "ENGLISH", description: "English" },
		{ code: "SPANISH", description: "español" }];

		return (
			<>
				<Container fluid="true" >
					<Row className='align-items-end'>
						<Col lg={8}>
							<Container style={{marginLeft: 0}}>
								<Row>
									<Col>
										<span style={{ color: '#003E7F', fontSize: 32, fontVariant: 'small-caps', fontWeight: 'bold' }}>{this.props.countyName} {this.props.appTitle}</span>
									</Col>
								</Row>
								<Row>
									<Col>
										<span style={{ fontSize: 20, fontWeight: 500, marginTop: 50 }}>&nbsp;powered by&nbsp;</span>
										<img border="0" src={landnotification_logo} alt="Trimin LandNotification" style={{ paddingBottom: 15 }} />
									</Col>
								</Row>
								{
									this.props.countyConfigUserLockout && this.props.countyConfigUserLockout.lockoutInPlace === true &&
									<Row>
										<Col>
											<div id="arrow" className="circle bounce" data-target="#introText">
												<span className="bounce" > {warningSmallIcon} <span style={{ position: 'relative', color: 'red', fontSize: 20, fontWeight: 'bold' }}>{this.props.countyConfigUserLockout.messageHeadline}</span></span>
											</div>
										</Col>
									</Row>
								}
							</Container>
						</Col>
						<Col lg={4} >
							<table className='float-right' style={{ marginRight: 20, fontSize: 16, fontWeight: 500 }}>
								<tbody>
									<tr>
										<td>
											<div style={{ color: '#6c757d' }}>
												<span className="align-bottom">{translations[this.props.language].hello}, {this.props.currentUserName}</span> 
												<Button variant="primary" className='btn-sm' onClick={this.handleClickCurrentUser} style={{ marginLeft: 5 }} role='button' aria-label='My User Profile'>{userProfileIcon}</Button> 
												<Button variant="danger" className='btn-sm' style={{ marginLeft: 5}} onClick={this.handleClickLogout}>{translations[this.props.language].logout}</Button> 
											</div>
										</td>
									</tr>
								
									{
									
										this.props.languages.languages === true &&
										<>
										
											<hr style={{ backgroundColor: '#000', marginTop: 6, marginBottom: 6, marginLeft: 0, marginRight: 0}}></hr>
											<tr>
												<td className='float-left'>
												<SelectField formGroup={{ id: 'language', layout: 'horizontal', label: translations[this.props.language].language, labelFor:'language', fieldType: 'select', value: this.props.language, options: languageOptions }} onChange={this.handleLanguageChange} />
												</td>
											</tr>
											</>
										
										}
									
									
								</tbody>
							</table>
						</Col>
					</Row>
				</Container>
				<Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
				<CurrentUser show={this.state.showCurrentUser} openCurrentUserChangePassword={this.handleClickCurrentUserChangePassword} closeCurrentUser={this.handleCloseCurrentUser} history={this.props.history}/>
				<CurrentUserChangePassword show={this.state.showCurrentUserChangePassword} openCurrentUser={this.handleClickCurrentUser} closeCurrentUserChangePassword={this.handleCloseCurrentUserChangePassword} history={this.props.history}/>
				<Logout show={this.state.showLogout} closeLogout={this.handleCloseLogout} history={this.props.history} />
			</>
		)
	}
}

export default connect(mapStateToProps, matchDispatchToProps)(InformationMain);